module.exports = function (Component) { Component.options.__i18n = '{"en":{"button_flip_video_horizontally":"Flip Video Horizontally","button_enable_music_mode":"Enable Music Mode","button_share_screen_title":"Share Screen"},"de":{"button_flip_video_horizontally":"Video horizontal spiegeln","button_enable_music_mode":"Musikmodus aktivieren","button_share_screen_title":"Bildschirm teilen"}}' }


//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/OptionsMenuSelect.vue
// module id = 146
// module chunks = 1